import { DynamicFormRequiredType, type DynamicFormSettings } from '@myosh/odin-components';
import type { RiskRatingValueDisplayKey } from '../../../../@types/forms';
import HfDropDownMultiSelect from '../../../../components/fields/custom-drop-downs/hf-drop-down-multi-select.component';
import HfDropDown from '../../../../components/fields/custom-drop-downs/hf-drop-down.component';
import i18next from '../../../../i18n';
import { riskMatrixApi } from '../../../../redux/services/risk-matrix';
import type { FormBuilderField } from '../../../../redux/slices/form-builder-slice';
import { appDispatch } from '../../../../redux/store-accessors';
import { dataSettings } from '../../../form-builder/util/common.util';

export const riskRatingValueDisplayOptions: Array<{ text: string; value: RiskRatingValueDisplayKey }> = [
  { text: i18next.t('rating'), value: 'RATING_NAME' },
  { text: i18next.t('risk-level'), value: 'RISK_LEVEL_NAME' },
  { text: i18next.t('category'), value: 'CATEGORY' },
  { text: i18next.t('consequence'), value: 'CONSEQUENCE_NAME' },
  { text: i18next.t('likelihood'), value: 'LIKELIHOOD_NAME' },
];

export const riskRatingFormSettings: DynamicFormSettings = {
  id: 'RiskRatingFieldSettingsGroup',
  caption: '',
  fields: [
    {
      id: 'riskMatrixId',
      fieldType: 'COMBOBOX',
      fieldName: 'riskMatrixId',
      caption: i18next.t('risk-matrix'),
      dataSettings: dataSettings,
      required: DynamicFormRequiredType.True,
      permissions: { edit: true, read: true },
      position: 40,
      dynamicProperties: {
        allowClear: false,
      },
    },
    {
      id: 'riskRatingValueDisplay',
      fieldType: 'DROPDOWNMULTISELECT',
      fieldName: 'riskRatingValueDisplay',
      caption: i18next.t('value-display-format'),
      dataSettings: dataSettings,
      required: DynamicFormRequiredType.True,
      permissions: { edit: true, read: true },
      position: 41,
      dynamicProperties: {
        data: riskRatingValueDisplayOptions,
      },
    },
    {
      id: 'displayDescription',
      fieldType: 'CHECKBOX',
      fieldName: 'displayDescription',
      caption: i18next.t('display-description'),
      required: DynamicFormRequiredType.False,
      permissions: { edit: true, read: true },
      position: 42,
    },
  ],
  customFieldComponents: {
    COMBOBOX: HfDropDown,
    DROPDOWNMULTISELECT: HfDropDownMultiSelect,
  },
};

export const getRiskMatrixValues = async (field: FormBuilderField) => {
  const riskMatrixId = field.riskMatrixId;

  const selectedRatings = field.riskRatingValueDisplay || [];
  const riskRatingValueDisplayValue =
    riskRatingValueDisplayOptions.filter((option) => selectedRatings.includes(option.value)) || [];

  const isChecked = field.displayDescription || false;
  const displayDescriptionValue = {
    name: 'displayDescription',
    value: isChecked,
    checked: isChecked,
  };

  const errorFallback = () => {
    console.error('There was error fetching risk matrix', riskMatrixId);
    return { data: { caption: riskMatrixId } };
  };

  const riskMatrix = riskMatrixId
    ? (await appDispatch(riskMatrixApi.endpoints.getRiskMatrixById.initiate(riskMatrixId)).catch(errorFallback)).data
        ?.caption
    : riskMatrixId;
  const riskMatrixIdValue = [{ value: riskMatrixId, text: riskMatrix }];

  return {
    riskMatrixId: riskMatrixIdValue,
    displayDescription: displayDescriptionValue,
    riskRatingValueDisplay: riskRatingValueDisplayValue,
  };
};
